var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"space left"}),_c('div',{staticClass:"page-skill-text"},[_c('Nav',{attrs:{"cateSub":_vm.info.cate_sub}}),_c('Detail',{attrs:{"info":_vm.info,"onRefresh":_vm.fetchInfo}})],1),_c('div',{staticClass:"space"})])
}
var staticRenderFns = []

export { render, staticRenderFns }